import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: { marginBlock: '8px' },
    text: { fontSize: 12 },
    divider: {
      margin: '0px 4px',
    },
    counter: {
      fontWeight: 'bold',
      color: palette.blue,
      fontSize: 12,
      marginLeft: 4,
      display: 'inline',
    },
  });
